import api from '../api/axiosConfig';

export const tasksApi = {
    createTask: async (taskData) => {
        const response = await api.post(`/tasks/`, taskData, {
            loadingMessage: 'Создание задачи...',
            successMessage: 'Задача успешно создана'
        });
        return response.data;
    },

    getTasks: async (skip = 0, limit = 100, filters = {}) => {
        const params = { skip, limit, ...filters };
        const response = await api.get(`/tasks/`, {
            params,
            silent: true
        });
        // Возвращаем и items, и total_pages, и total_items из ответа бэкенда
        return {
            items: response.data.data.items || response.data.data,
            total_pages: response.data.data.total_pages,
            total_items: response.data.data.total_items
        };
    },

    getTaskById: async (taskId) => {
        const response = await api.get(`/tasks/${taskId}`, {
            silent: true
        });
        return response.data;
    },

    getTasksByCandidate: async (candidateId, skip = 0, limit = 100) => {
        const response = await api.get(`/tasks/candidates/${candidateId}`, {
            params: { skip, limit },
            silent: true
        });
        return response.data.data;
    },

    updateTask: async (taskId, taskData) => {
        const response = await api.put(`/tasks/${taskId}`, taskData, {
            loadingMessage: 'Обновление задачи...',
            successMessage: 'Задача успешно обновлена'
        });
        return response.data;
    },

    updateTaskStatus: async (taskId, status) => {
        const response = await api.put(`/tasks/${taskId}`, { status }, {
            loadingMessage: 'Изменение статуса задачи...',
            successMessage: 'Статус задачи успешно изменён'
        });
        return response.data;
    },

    deleteTask: async (taskId) => {
        const response = await api.delete(`/tasks/${taskId}`, {
            loadingMessage: 'Удаление задачи...',
            successMessage: 'Задача успешно удалена'
        });
        return response.data;
    },

    getTaskHistory: async (taskId) => {
        const response = await api.get(`/tasks/${taskId}/history`, {
            silent: true
        });
        return response.data.data;
    },

    getTaskFiles: async (taskId) => {
        const response = await api.get(`/tasks/${taskId}/files`, {
            silent: true
        });
        return response.data.data;
    },

    uploadTaskFile: async (taskId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`/tasks/${taskId}/files`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            loadingMessage: 'Загрузка файла...',
            successMessage: 'Файл успешно загружен'
        });
        return response.data;
    }
}